import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import '../runtime/styles/index.css';
import AppEntry from './AppEntry.jsx';
import reportWebVitals from '../runtime/reportWebVitals.js';

function removeBootSkeleton() {
  const node = document.getElementById('boot-skeleton');
  if (!node) return;
  if (node.dataset.removing === '1') return;
  node.dataset.removing = '1';
  node.style.transition = 'opacity 160ms ease';
  node.style.opacity = '0';
  window.setTimeout(() => {
    node.remove();
  }, 180);
}

function hasRenderableRootContent() {
  const rootEl = document.getElementById('root');
  if (!rootEl) return false;
  if (rootEl.childElementCount > 0) return true;
  const text = (rootEl.textContent || '').trim();
  return text.length > 0;
}

function hideBootSkeletonWhenReady() {
  const maxWaitMs = 4000;
  const startAt = Date.now();
  const tick = () => {
    if (hasRenderableRootContent()) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          removeBootSkeleton();
        });
      });
      return;
    }
    if (Date.now() - startAt >= maxWaitMs) {
      removeBootSkeleton();
      return;
    }
    window.setTimeout(tick, 16);
  };
  tick();
}

window.__HIDE_BOOT_SKELETON__ = hideBootSkeletonWhenReady;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <AppEntry />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
